import React from 'react';
import { connect } from 'react-redux';

import AuthService from '../services/authService';
import { appConf } from '../appConf';

const WebPushNotificationContainer = props => {
  const { token } = props;

  /**
   * Browser support check
   */
  const isSupported = () => {
    return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
  };

  /**
   * Convert base64 to Uint8Array
   */
  const urlBase64ToUint8Array = base64String => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);

    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);

    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
  };

  const unsubscribeUser = async () => {
    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();

      if (subscription) {
        await AuthService.unsubscribePushNotification(subscription);

        await subscription.unsubscribe();
        console.log('User unsubscribed from push notifications');
      }
    } catch (error) {
      console.error('Failed to unsubscribe user:', error);
    }
  };

  /**
   * Subscribe user
   */
  const subscribeUser = async () => {
    try {
      if (Notification.permission !== 'granted') {
        return;
      }

      const registration = await navigator.serviceWorker.ready;

      let subscription = await registration.pushManager.getSubscription();

      /**
       * Already subscribed
       */
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(appConf.publicVapidKey)
        });
      }

      /**
       * Save subscription to backend
       */
      await AuthService.subscribePushNotification(subscription);

      console.log('Push notification subscribed');
    } catch (error) {
      console.error('Subscription failed:', error);
    }
  };

  /**
   * Ask notification permission automatically
   */
  const requestPermission = async () => {
    try {
      if (!isSupported()) {
        return;
      }

      /**
       * Already granted
       */
      if (Notification.permission === 'granted') {
        await unsubscribeUser();
        await subscribeUser();
        return;
      }

      /**
       * Already denied
       */
      if (Notification.permission === 'denied') {
        console.log('Notification permission denied');
        return;
      }

      /**
       * Ask permission popup
       */
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {
        await unsubscribeUser();
        await subscribeUser();
      }
    } catch (error) {
      console.error('Permission request failed:', error);
    }
  };

  /**
   * Auto ask permission after login
   */
  React.useEffect(() => {
    if (token) {
      requestPermission();
    }
  }, [token]);

  React.useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    const handleMessage = event => {
      const { type = null, payload } = event.data || {};

      if (type === 'SILENT_PUSH') {
        console.log('Silent push received in React:', payload);

        // Dispatch Redux action
        // props.handleDynamicData(payload);

        // Or refresh data
        // getVehicles();

        // Or update state
        // setData(payload);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
    };
  }, []);

  return null;
};
const mapStateToProps = state => ({
  token: state?.auth?.token
});

const mapDispatchToProps = {
  //   handleDynamicData,
  //   setEnableNotification,
  //   setNotificationServerError
};

export default connect(mapStateToProps, mapDispatchToProps)(WebPushNotificationContainer);
// export default WebPushNotificationContainer;
